<template>
  <div class="login-panel">
    <div class="login-container">
      <div class="login-container-header">
        <h1>
          Bankszámla kalkulátor
        </h1>
        <img :src="calculatorLogo" alt="Calculator logo" style="height:140px;transform: translateY(16px);" />
      </div>
      <div class="separator"></div>


      <v-alert v-model="alert" :type="alertType" close-text="Bezárás" dismissible @click="alert = false">
        {{ alertMessage }}
      </v-alert>

      <div class="form-container">
        <p class="form-header">
          add meg az adataid
        </p>
        <div class="form-row">
          <label class="form-label">jelenlegi bank</label>
          <vpd-select v-model="selectedBank" value-key="id" :options="banks" placeholder="válassz"
            :error="showSelectError" error-message="A bank kiválasztása kötelező" @change="onBankChange" />
        </div>
        <div class="form-row">
          <label class="form-label">e-mail cím</label>
          <vpd-input v-model="email" type="email" placeholder="valami@gmail.com" :error="showEmailError"
            :error-message="emailErrorMessage" @input="onEmailChange" @blur="onEmailBlur" />
        </div>
        <div class="form-row">
          <label class="form-label">telefonszám</label>
          <vpd-phone-input v-model="phone" :defaultIso2="'hu'" placeholder="" :error="showPhoneError"
            :error-message="phoneErrorMessage" @valid="onPhoneValid" @input="onPhoneChange" @blur="onPhoneBlur" />
        </div>
      </div>

      <div class="check-box-container">
        <div class="check-box-data-container-fixed-sm">
          <div class="checkbox">
            <label class="custom-checkbox-container checkbox-label " for="terms">
              Elfogadom az <a href="https://bankszamlakivonat.hu/wp-content/uploads/2025/04/Hatalyos_ASZF.pdf"
                target="_blank">Általános szerződési feltételeket</a><span class="asterisk">*</span>
              <input v-model="termsStatus" type="checkbox" required id="terms" name="terms" @change="termsChange">
              <span :class="showTermsError ? 'checkbox-error' : ''" class="custom-checkmark"></span>
            </label>
          </div>
          <div v-if="showTermsError" class="checkbox-error-container">
            <img :src="errorLogo" alt="Checkbox error logo" style="height:18px" />
            <span class="checkbox-error">A szabályzat elfogadása kötelező</span>
          </div>
        </div>

        <div class="check-box-data-container-fixed-sm">
          <div class="checkbox">
            <label class="custom-checkbox-container checkbox-label " for="privacy">
              Elfogadom az <a
                href="https://bankszamlakivonat.hu/wp-content/uploads/2025/04/Hatalyos_Adatkezelesi-Tajekoztato.pdf"
                target="_blank">Adatkezelési tájékoztatót</a>
              <span class="asterisk">*</span>
              <input v-model="privacyStatus" type="checkbox" required id="privacy" name="privacy"
                @change="privacyChange">
              <span :class="showPrivacyError ? 'checkbox-error' : ''" class="custom-checkmark"></span>
            </label>
          </div>
          <div v-if="showPrivacyError" class="checkbox-error-container">
            <img :src="errorLogo" alt="Checkbox error logo" style="height:18px" />
            <span class="checkbox-error">A szabályzat elfogadása kötelező</span>
          </div>
        </div>
        <div class="check-box-data-container-fixed-xl">
          <div class="checkbox">
            <label class="custom-checkbox-container checkbox-label " for="data">
              Hozzájárulok, hogy a személyes adataim a K&H
              Bank Zrt. részére átadásra kerüljenek kapcsolatfelvétel céljából. A K&H Bank adatkezelési tájékoztatója
              <a href="https://bankszamlakivonat.hu/wp-content/uploads/2025/12/Bankszamla_kalkulator-Adatkezelesi-tajekoztato-20251208.pdf"
                target="_blank">itt</a> érhető el.
              <input v-model="dataStatus" type="checkbox" id="data" name="data" @change="userAcceptedChange">
              <span class="custom-checkmark"></span>
            </label>
          </div>
        </div>
      </div>

      <div class="calculation-button-container">
        <div class="calculation-button" @click="submit">
          <span v-if="!loading">kalkuláció indítása</span>
          <img v-else :src="loaderIcon" class="spin" alt="Töltés" style="height:24px;" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "./_vpd-login-panel.scss";
import calculatorLogo from "@/assets/calculator-logo.svg";
import loaderIcon from "@/assets/loader.svg";
import errorLogo from "@/assets/error-icon.svg";
import vpdInput from "../../vpd-input/vpd-input.vue";
import vpdPhoneInput from "../../vpd-phone-input/vpd-phone-input.vue";
import vpdSelect from "../../vpd-select/vpd-select.vue";

export default {
  components: { vpdInput, vpdPhoneInput, vpdSelect },
  data: () => ({
    calculatorLogo,
    errorLogo,
    loaderIcon,
    selectedBank: null,
    email: "",
    phone: "",
    privacyStatus: false,
    termsStatus: false,
    dataStatus: false,
    showPrivacyError: false,
    showTermsError: false,
    showSelectError: false,
    showEmailError: false,
    emailErrorMessage: "Az e-mail cím megadása kötelező",
    showPhoneError: false,
    phoneErrorMessage: 'A telefonszám megadása kötelező',
    phoneTouched: false,
    phoneIsValid: false,
    emailRules: [
      (v) => !!v || "Az email cím kötelező",
      (v) => /.+@.+/.test(v) || "Érvénytelen email",
    ],
    banks: [],
    alert: false,
    alertType: "error",
    alertMessage: "",
  }),
  props: {
    config: {
      type: Object,
    },
    loading: {
      type: Boolean,
    }
  },
  methods: {
    onBankChange(bank) {
      this.showSelectError = bank === null;
    },
    onEmailChange(email) {
      this.showEmailError = email === '';

      if (this.showEmailError) {
        this.emailErrorMessage = "Az e-mail cím megadása kötelező"
      }
    },
    onEmailBlur() {
      if (this.showEmailError) {
        return;
      }
      this.showEmailError = !(/^[^\s<>(){}\[\]\\,;:\"]+@[^\s<>(){}\[\]\\,;:\"]+\.[a-zA-Z]{2,}$/.test(this.email.trim()));
      if (this.showEmailError) {
        this.emailErrorMessage = "Érvénytelen email"
      }
    },
    onPhoneValid(isValid) {
      this.phoneIsValid = isValid;

      // Only show error if field was already touched
      if (this.phoneTouched && !isValid && this.phone !== '') {
        this.showPhoneError = true;
        this.phoneErrorMessage = 'A telefonszámnak pontosan 9 számjegyből kell állnia.';
      } else if (isValid) {
        this.showPhoneError = false;
      }
    },

    onPhoneChange(phone) {
      // Clear error when user empties or when valid
      if (phone === '') {
        this.showPhoneError = false;
      }
    },

    onPhoneBlur() {
      this.phoneTouched = true;

      if (this.phone === '') {
        this.showPhoneError = true;
        this.phoneErrorMessage = 'A telefonszám megadása kötelező';
      } else if (!this.phoneIsValid) {
        this.showPhoneError = true;
        this.phoneErrorMessage = 'A telefonszámnak pontosan 9 számjegyből kell állnia.';
      }
    },
    privacyChange() {
      this.showPrivacyError = !this.privacyStatus;
    },
    termsChange() {
      this.showTermsError = !this.termsStatus;
    },
    userAcceptedChange() {
      if (!this.dataStatus) return;
    },
    submit() {
      if (this.loading) {
        return;
      }

      if (this.selectedBank === null) {
        this.showSelectError = true;
      }

      if (this.email === '') {
        this.showEmailError = true;
      }

      if (this.phone === '') {
        this.showPhoneError = true;
        this.phoneErrorMessage = 'A telefonszám megadása kötelező';
      } else if (!this.phoneIsValid) {
        this.showPhoneError = true;
        this.phoneErrorMessage = 'A telefonszámnak pontosan 9 számjegyből kell állnia.';
      }

      if (!this.privacyStatus) {
        this.showPrivacyError = true;
      }

      if (!this.termsStatus) {
        this.showTermsError = true;
      }

      if (!this.privacyStatus || !this.termsStatus || !this.selectedBank || this.email === '' || this.phone === '') {
        return;
      }

      this.$emit("submit", this.email, this.phone, this.selectedBank, this.dataStatus);
    },
    showAlert(text, type) {
      this.alert = true;
      this.alertType = type;
      this.alertMessage = text;
    },
  },
  created() {
    this.banks = this.config.aspspProviders;
  }
};
</script>
